import {FETCH_MSISDN} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_MSISDN:
            return action.payload;
        default:
            return state;
    }
};